import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'
import { useDispatch, useSelector } from 'react-redux'
import Loader from '../../../../CustomComponents/Loader'
import DynamicCard from '../../../../CustomComponents/DynamicCard';
import { width } from '../../../../CustomComponents/DynamicCard/DynamicCardStyles'
import { withOidcSecure } from '@axa-fr/react-oidc'
import CustomRadioButtonGroup from '../../../../CustomComponents/CustomRadioButton'
import checkbox_fill from "../../../../../assets/images/Checkbox-blue.png"
import checkbox_null from "../../../../../assets/images/Checkbox-light.png"
import logFirebaseEvents from '../../../../LogFirebaseEvents'
import { appTheme } from '../../../../../helpers/utils/Utils'
import CardHeading from '../../../../CustomComponents/CardHeading'
import { addLineBreaks } from '../../../../../utils'

const AllocateNotificationType = ({ cardHeader, cardFooter, onBack, onNext }) => {

  const kudzuPlusTrue = useSelector(state => state.kudzuPlusTrue); 
    const appThemeData = appTheme(kudzuPlusTrue);
  const { t } = useTranslation();
  const navigate = useNavigate()
  const dispatch = useDispatch();
  const [NotificationError, setNotificationError] = useState(null)
  const [notification, setNotification] = useState('')
  const [notificationError, setnotificationError] = useState(null)
  const [isNext, setIsNext] = useState(false);


  const NotificationTypeSMS = useSelector(state => state.allocateFund.sms)
  const NotificationTypeEmail = useSelector(state => state.allocateFund.email)
  const [notificationArray, setNotificationArray] = useState([{ displayText: t('text'), isSelected: NotificationTypeSMS }, { displayText: t('email'), isSelected: NotificationTypeEmail }])



  const [isLoading, setIsLoading] = useState(false);



  const setNotificationFun = (option) => {
    debugger
    const selectedIndex = notificationArray.findIndex(
      (item) => item.displayText === option.displayText
    );
    notificationArray[selectedIndex] = { ...option, 'isSelected': !option?.isSelected }
    setNotificationArray([...notificationArray])
    if (option.displayText === "Email") {
      dispatch({
        type: 'ALLOCATE_FUND',
        payload: { 'key': 'email', 'value': !option?.isSelected }
      });
    } else {
      dispatch({
        type: 'ALLOCATE_FUND',
        payload: { 'key': 'sms', 'value': !option?.isSelected }
      });

    }
  }

// const setNotificationFun = (option) => {
//     const updatedArray = notificationArray.map((item) =>
//       item.displayText === option.displayText
//         ? { ...item, isSelected: !option.isSelected }  
//         : { ...item, isSelected: false }  
//     );
  
//     setNotificationArray(updatedArray);
  
//     const selectedKey = option.displayText === "Email" ? "email" : "sms";
//     dispatch({
//       type: 'ALLOCATE_FUND',
//       payload: { key: selectedKey, value: !option.isSelected }
//     });
//   };
  

  const handleBackClick = () => {
    logFirebaseEvents("Allocate_Fund", "Back_Notification_Clicked", "Back_Notification_Clicked","", "")
    onBack("AllocateDateCard")
  }
  const handleNextClick = () => {
    logFirebaseEvents("Allocate_Fund", "Next_Notification_Clicked", "Next_Notification_Clicked","", "")
    //debugger;
    if (!NotificationTypeSMS && !NotificationTypeEmail) {
      setnotificationError('Choose Notification Type');
    } else {
      setnotificationError('');
      onNext("AllocateConfirmationCard")
    }

  }

  useEffect(()=>{
    if(!NotificationTypeSMS && !NotificationTypeEmail) setIsNext(false);
    else setIsNext(true);
  },[NotificationTypeSMS,NotificationTypeEmail])

  const children = () => {
    return (
      <>
        {/* {cardHeader} */}

        <div  className="sm:w-[auto] w-[257px] font-serif-pro font-[400] lg:text-[26px] md:text-[24px]
            sm:text-[22px] text-[25px] leading-[32px] sm:leading-[30px] md:leading-[36px] 
                text-[var(--text-clrs)] mt-6 sm:mx-0 mx-4"
            >
           {t("terms_and_condition_heading")}  

          <span className='text-[var(--matter-add-spendSense)]'> {addLineBreaks(t("About_Saving_Goal"))}</span>
        </div>

        <div className='w-full flex justify-center md:mb-32'>
          <div className="sm:w-[80%] w-full">
            {/* BODY */}
            <div className='md:my-20 sm:my-16 mt-10 mb-[9rem] sm:mx-0 mx-4'>
              <div className='w-full flex flex-col justify-center'>
                <div className='sm:w-[60%] md:w-[50%] '>
                  <CustomRadioButtonGroup
                    title={t('spending_alert_notification_title')}
                    options={notificationArray}
                    onSelect={setNotificationFun}
                    fillIcon={checkbox_fill}
                    nullIcon={appThemeData.shownullMarvel}
                    error={notificationError}
                  />

                </div>


                <p className='mt-4 font-hanken-grotesk text-[var(--notify-type-clr)] 
                 text-[12px] leading-[30px] 
                  font-normal'>{t('standard_message')}</p>
              </div>
            </div>
          </div>

        </div >
        {/* FOOTER */}

        {cardFooter(handleBackClick, handleNextClick,'','', isNext)}
        {/* ---------- */}
      </>
    )
  }
  return (
    <>
      <DynamicCard
        header={false}
        CardRadius={true}
        cardWidth={width.homeCard}
        HeaderRadius={true}
        isWhite={appThemeData.isWhiteBgForCard}
        isDarkForKudzu={appThemeData.isDarkBgForCard}
        backgroundColor={'--cardHeading-bg'} 
        HeaderContent={
            <>
                <CardHeading heading={t('Allocate_Funds')} />
            </>
        }
        footer={true}
       >
        {children()}
      </DynamicCard>
      {isLoading && <Loader />}
    </>
  )
}


export default withOidcSecure(AllocateNotificationType)


